import { UserComponent } from '@craftjs/core';
import { FormFieldWithOptionsProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormCheckboxGroupInputProps = FormFieldWithOptionsProps & {
  isVertical?: boolean;
};

export const formCheckboxGroupInputDefaultProps: FormCheckboxGroupInputProps = {
  title: 'Checkboxes',
  dataKey: createId(),
  options: [
    {
      key: createId(),
      value: 'Option 1',
    },
    {
      key: createId(),
      value: 'Option 2',
    },
  ],
};

export type FormCheckboxGroupInputComponent = UserComponent<FormCheckboxGroupInputProps>;
